/**
 * Adds logic to compose linkedIn profile urls
 * @param alias
 * @returns
 */
export function createLinkedInProfileUrl(alias: string): string {
    return `https://www.linkedin.com/in/${alias}`;
}
